import script from "./CreateUpdateVistoria.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateUpdateVistoria.vue?vue&type=script&setup=true&lang=js"

import "./CreateUpdateVistoria.vue?vue&type=style&index=0&id=d6ad892e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6ad892e"]])

export default __exports__